






























































































import Vue from 'vue'
import ProjectNotes from '@/components/project/ProjectNotes.vue'
import ProjectAdditionalFields from '@/components/project/ProjectAdditionalFields.vue'
import ProjectForm from '@/components/project/ProjectForm.vue'
import {
  DELETE_PROJECT,
  GET_PROJECT_DETAIL,
  GET_PROJECT_DETAIL_FOOTER,
  GET_PROJECT_DETAIL_HEADER
} from '@/store/action-types'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import { ProjectDetailFooter } from '@/model/project/ProjectDetailFooter'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'
import ProjectReprintAndCancellation from '@/components/project/ProjectReprintAndCancellation.vue'
import ProjectBookingAssistant from '@/components/project/ProjectBookingAssistant.vue'
import ProjectBookAssistant from '@/components/project/ProjectBookAssistant.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DeleteProjectPayload } from '@/types/payload'
import { ResponseBase } from '@/types/service-response'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import CreateProjectAssistant from '@/components/project/CreateProjectAssistant.vue'
import CommissionDocuments from '@/components/master-data/commissions/CommissionDocuments.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  activeTab: number
  projectDetail: ProjectDetail[] | undefined
  projectDetailHeader: ProjectDetailHeader | undefined
  projectDetailFooter: ProjectDetailFooter | undefined
  selectedProjectId: number | undefined
  projectIdIndex: number

  isCreateProject: boolean
  isEditProject: boolean
  showWarningDialog: boolean
  warningMessage: string
  showCreateProjectAssistant: boolean
  loadingEdit: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProjectWindow',

  components: {
    ProgressCircular,
    ProjectForm,
    ProjectAdditionalFields,
    ProjectNotes,
    ProjectBookingAssistant,
    ProjectBookAssistant,
    ProjectReprintAndCancellation,
    WarningDialog,
    CreateProjectAssistant,
    CommissionDocuments
  },

  props: {
    showDialog: Boolean,
    projectIdList: Array as () => number[],
    showCreateAssistant: Boolean
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      activeTab: 0,
      projectDetail: undefined,
      projectDetailHeader: undefined,
      projectDetailFooter: undefined,
      selectedProjectId: undefined,
      projectIdIndex: 0,

      isCreateProject: false,
      isEditProject: false,
      showWarningDialog: false,
      warningMessage: '',
      showCreateProjectAssistant: false,
      loadingEdit: false,

      keyActions: []
    }
  },

  watch: {
    showCreateAssistant (newVal: boolean): void {
      if(newVal) {
        this.showCreateProjectAssistant = true
      }
    },

    activeTab (newVal: number): void {
      if(this.$route.path === '/project') {
        let data: any = this.getRouteData()
        data.projectTab = newVal
        this.$router.push({ name: 'Project', query: { data: JSON.stringify(data) } })
      }
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    isProjectBeforeDisabled (): boolean {
      return this.projectIdIndex === 0
    },

    isProjectAfterDisabled (): boolean {
      return this.projectIdIndex === this.projectIdList.length -1
    },

  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create && this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditProject
      } else if(action instanceof Edit && this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditProject
      } else if(action instanceof Delete && this.activeTab === 0 || this.activeTab === 1 || this.activeTab === 5) {
        return !this.isEditProject
      } else if(action instanceof Search && this.activeTab !== 4) {
        return true
      } else {
        return false
      }
    },

    onAddProjectClick (): void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.activeTab = 0
      //this.isCreateProject = true
      //this.isEditProject = false
      this.showCreateProjectAssistant = true
    },

    onCloseCreateProjectClick (): void {
      this.showCreateProjectAssistant = false
    },

    onCreatedProject(projectId: number) : void {
      this.showCreateProjectAssistant = false
      this.projectIdIndex = 0
      this.selectedProjectId = projectId
      this.fetchData()
      this.$emit('createProject', projectId)
    },

    onCreated (item: number): void {
      this.fetchData()
      this.isCreateProject = false
    },

    onCancelProjectHeaderClick (): void {
      this.isCreateProject = false
      this.isEditProject = false
    },

    onEditProjectClick (): void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.activeTab = 0
      this.isEditProject = true
      this.isCreateProject = false
    },

    onEditLoading (item: boolean): void {
      this.loadingEdit = item
    },

    onEdited (): void {
      this.fetchData()
      this.isEditProject = false
      this.$emit('editedProject')
    },

    updateData (): void {
      this.fetchData()
    },

    onDeleteProjectClick (): void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.warningMessage = this.$t('project.deleteProjectMessage').toString()
      this.showWarningDialog = true
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    async onWarningDialogSave (): Promise<void> {
      this.showWarningDialog = false
      if(this.selectedProjectId) {
        const payload: DeleteProjectPayload = {
          ID: this.selectedProjectId,
          LanguageId: this.selectedLanguageId
        }

        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(DELETE_PROJECT, payload)
          this.loading = false
          if (!response.IsError) {
            this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.$emit('deleteProject', this.selectedProjectId, this.projectIdIndex)
            if (this.projectIdList.length > 0) {
              if (this.projectIdIndex === this.projectIdList.length) {
                this.onProjectBeforeClick()
              } else {
                //this.selectedProjectId = this.projectIdList[this.projectIdIndex]
                this.onCloseDialog()
                this.fetchData()
              }
            }
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onProjectBeforeClick (): void {
      this.projectIdIndex -= 1
      this.selectedProjectId = this.projectIdList[this.projectIdIndex]
      let data: any = this.getRouteData()
      data.projectIdIndex = this.projectIdIndex
      this.$router.push({name: 'Project', query: { data: JSON.stringify(data) }})
      this.fetchData()
    },

    onProjectAfterClick (): void {
      this.projectIdIndex += 1
      this.selectedProjectId = this.projectIdList[this.projectIdIndex]
      let data: any = this.getRouteData()
      data.projectIdIndex = this.projectIdIndex
      this.$router.push({name: 'Project', query: { data: JSON.stringify(data) }})
      this.fetchData()
    },

    onSearchClick (): void {
      this.search()
    },

    search (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.$emit('close')
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    async createdDetail (): Promise<void> {
      this.projectDetail = await this.$store.dispatch(GET_PROJECT_DETAIL, this.selectedProjectId)
      this.projectDetailFooter = await this.$store.dispatch(GET_PROJECT_DETAIL_FOOTER, this.selectedProjectId)
    },

    async updatedDetail (): Promise<void> {
      this.projectDetail = await this.$store.dispatch(GET_PROJECT_DETAIL, this.selectedProjectId)
      this.projectDetailFooter = await this.$store.dispatch(GET_PROJECT_DETAIL_FOOTER, this.selectedProjectId)
    },

    async deletedDetail (item: ProjectDetail): Promise<void> {
      if(this.projectDetail) {
        const index: number = this.projectDetail.indexOf(item)
        this.projectDetail.splice(index, 1)
      }
      this.projectDetailFooter = await this.$store.dispatch(GET_PROJECT_DETAIL_FOOTER, this.selectedProjectId)
    },

    async fetchData (): Promise<void> {
      this.loading = true
      try {
        this.projectDetailHeader = await this.$store.dispatch(GET_PROJECT_DETAIL_HEADER, this.selectedProjectId)
        this.projectDetail = await this.$store.dispatch(GET_PROJECT_DETAIL, this.selectedProjectId)
        this.projectDetailFooter = await this.$store.dispatch(GET_PROJECT_DETAIL_FOOTER, this.selectedProjectId)
      } catch {

      } finally {
        this.loading = false
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/project') {
        this.projectIdIndex = data && data.projectIdIndex ? data.projectIdIndex : 0
        if(this.projectIdList[this.projectIdIndex]) {
          this.selectedProjectId = this.projectIdList[this.projectIdIndex]
        } else {
          this.selectedProjectId = this.projectIdList[0]
        }
        this.activeTab = data.projectTab
      } else {
        this.projectIdIndex = 0
        this.selectedProjectId = this.projectIdList[0]
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.search, this.resolver, null)
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.setDataFromRoute()
    this.fetchData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
